// @flow

import React, { Component } from 'react';
import './ImageCard.scss';

type Props = {
  smallUrl: string,
  largeUrl: string,
  alt: ?string
}

class ImageCard extends Component<Props> {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  onLoadImage = () => {
    if (this.img.clientWidth > this.imgWrapper.clientWidth) {
      this.img.style.width = `${this.imgWrapper.clientWidth}px`;
    }
    this.setState({ loaded: true });
  }

  render() {
    const { loaded } = this.state;
    const { smallUrl, largeUrl, alt = '' } = this.props;

    return (
      <div className="image-card">
        <div className="image-card__wrapper">
          { !loaded && <i className="icon-image" />}
          <a
            href={largeUrl}
            download
            target="_blank"
            className="image-card__content"
            rel="noopener noreferrer"
            ref={(el) => { this.imgWrapper = el; }}>
            <img
              src={smallUrl}
              style={{ opacity: loaded ? 1 : 0 }}
              alt={alt}
              onLoad={this.onLoadImage}
              ref={(el) => { this.img = el; }} />
          </a>
        </div>
        <div className="aspect-ratio-placeholder" />
      </div>
    );
  }
}

export default ImageCard;
